import Model from 'src/storage/base';

class PasswordModel extends Model {
  id = 'PasswordModel';
  persistent = false;

  defaultState = () => ({
    signupUrl: '/signup',
    codeLength: 7,
    resetByPhone: false,
    verified: false,
    code: '',
    email: '',
    phoneNumber: '',
    password1: '',
    password2: '',
    authData: null,
    resetExpired: 0
  });

  apiConfig = {
    password: {
      url: 'auth/password',
      validation: {
        username: 'emailAddress',
        password: 'password'
      },
      cancellable: true
    },
    forgotPw: {
      url: 'password/reset',
      validation: {
        email: 'emailAddress'
      },
      cancellable: true
    },
    verify: {
      url: 'password/verify',
      validation: {
        code: 'required'
      },
      cancellable: true
    },
    resetPw: {
      url: 'password/change',
      validation: {
        password1: 'password',
        password2: 'password',
        code: 'string'
      }
    }
  };

  _events = {
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.cacheState = { countryAddress: data.country };
    this.setState({ countryAddress: data.country });
  };

  loginPassword = (req, cb) => {
    this.api('password', req, (error, data, success) => {
      if (success) {
        this.emit('auth', data);
        cb();
      }
    });
  };

  forgotPw = (cb) => {
    let req = {
      email: this.state.email,
      phoneNumber: this.state.phoneNumber,
      byPhone: this.state.resetByPhone
    };

    if (this.state.resetByPhone) {
      this.apiConfig.forgotPw.validation = {
        phoneNumber: 'phoneNumber'
      };
    } else {
      this.apiConfig.forgotPw.validation = {
        email: 'emailAddress'
      };
    }
    this.api('forgotPw', req, (error, res, success) => {
      if (success) {
        this.setState({
          code: '',
          password1: '',
          password2: '',
          codeLength: res.codeLength || 7
        });
      }
      if (cb) cb(error, res, success);
    });
  };

  verify = (cb) => {
    const { code } = this.state;

    let req = {
      code
    };
    this.api('verify', req, (error, res, success) => {
      if (cb) cb(error, res, success);
    });
  };

  resetPw = (cb) => {
    const { password1, password2, code } = this.state;

    if (password1 !== password2) {
      this.setInvalidApi('resetPw', { password2: 'Does not match with password' });

      return;
    }

    let req = {
      password1: password1,
      password2: password2,
      code
    };
    this.api('resetPw', req, (error, res, success) => {
      if (success) {
        this.setState({
          ...this.defaultState(),
          authData: { username: res.email, password: password1 }
        });
      }
      if (cb) cb(error, res, success);
    });
  };
}

const model = new PasswordModel();
export default model;
